module.exports = __webpack_public_path__ + "img/stock5.f17e7f61.png";